import React, {useState, useEffect} from 'react'

const messages = {
  es: {
    title:  'Acceso a red local',
    body:   'Esta escuela tiene un servidor local que puede mejorar la velocidad de carga del contenido. ¿Desea permitir el acceso?',
    allow:  'Permitir',
    skip:   'Omitir',
  },
  en: {
    title:  'Local Network Access',
    body:   'This school has a local server that can improve content loading speed. Would you like to allow access?',
    allow:  'Allow',
    skip:   'Skip',
  }
}

function getLang() {
  const match = location.hash.match(/\/(es|en)\//)
  return (match && match[1]) || 'es'
}

export default function EdgePermissionBanner({onAllow, onSkip}) {
  const t = messages[getLang()] || messages.es

  return (
    <div style={{
      position:       'fixed',
      top:            '24px',
      left:           '50%',
      transform:      'translateX(-50%)',
      background:     '#1a73e8',
      color:          '#fff',
      borderRadius:   '8px',
      padding:        '16px 20px',
      boxShadow:      '0 4px 12px rgba(0,0,0,0.2)',
      zIndex:         9999,
      maxWidth:       '420px',
      width:          'calc(100% - 48px)',
      display:        'flex',
      flexDirection:  'column',
      gap:            '10px',
      fontFamily:     'sans-serif',
      fontSize:       '14px',
    }}>
      <strong style={{fontSize: '15px'}}>{t.title}</strong>
      <span>{t.body}</span>
      <div style={{display: 'flex', gap: '10px', justifyContent: 'flex-end'}}>
        <button
          onClick={onSkip}
          style={{
            background:   'transparent',
            border:       '1px solid rgba(255,255,255,0.6)',
            color:        '#fff',
            borderRadius: '4px',
            padding:      '6px 14px',
            cursor:       'pointer',
            fontSize:     '13px',
          }}
        >{t.skip}</button>
        <button
          onClick={onAllow}
          style={{
            background:   '#fff',
            border:       'none',
            color:        '#1a73e8',
            borderRadius: '4px',
            padding:      '6px 14px',
            cursor:       'pointer',
            fontWeight:   'bold',
            fontSize:     '13px',
          }}
        >{t.allow}</button>
      </div>
    </div>
  )
}
